import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss'],
})
export class InputSearchComponent {
    @Input() value!: string
    @Output() search: EventEmitter<string> = new EventEmitter<string>();
    submit(query:string) {
        this.search.emit(query);
    }
}
